<div class="fixed top-0 left-0 w-full h-full bg-transparent" (click)="toggleFilters()"></div>

<div class="z-99 relative overflow-y-scroll h-full w-full bg-white max-w-xl shadow-lg">
    <div class="max-w-screen-md m-0-auto p-6">
        <div class="flex items-center justify-between">
            <h1 class="font-bold text-2xl">Filtri</h1>
            <button class="bg-transparent rounded-lg border-0 p-2.5" title="Chiudi" (click)="toggleFilters()">
                <svg class="fill-black size-5">
                    <use href="../../../assets/svg/svGP.svg#close"></use>
                </svg>
            </button>
        </div>
        <hr class="my-5 border-light-grey" />
        @if (availableFilters$ | async; as availableFilters) {
        <div class="mt-2">
            <form *ngIf="searchProductFilterForm" [formGroup]="searchProductFilterForm" (submit)="submitForm()">
                <div class="flex flex-col">
                    @if (availableFilters.categories.length > 0) {
                    <div class="flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-4">
                            <label class="font-semibold text-base">Categoria</label>
                            <button type="button" class="text-base text-danger font-light" (click)="resetCategories()">Ripristina
                            </button>
                        </div>
                        <div class="flex items-start justify-start flex-wrap">
                            <label *ngFor="let category of availableFilters.categories; let i = index" class="cursor-pointer px-4 py-2 rounded-xl border mr-2 mb-4 inline-block text-sm border-primary transition-color duration-75 capitalize" [class.bg-primary]="searchProductFilterForm.controls.categories.controls[i].value" [class.text-white]="searchProductFilterForm.controls.categories.controls[i].value" [class.bg-white]="!searchProductFilterForm.controls.categories.controls[i].value" [class.text-primary]="!searchProductFilterForm.controls.categories.controls[i].value">
                                <input type="checkbox" class="hidden" [formControl]="searchProductFilterForm.controls.categories.controls[i]" />
                                {{ getCategoryLabel(category) }}
                            </label>
                        </div>
                    </div>

                    <hr class="my-5 border-light-grey" />
                    }

                    <div class="flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-4">
                            <label class="font-semibold text-base">Tipologia</label>
                            <button type="button" class="text-base text-danger font-light" (click)="resetFamilies()">Ripristina
                            </button>
                        </div>
                        <div class="flex items-center mb-4" *ngFor="let family of availableFilters.families; let i = index">
                            <input id="family-{{i}}" type="checkbox" [formControl]="searchProductFilterForm.controls.families.controls[i]" class="w-4 h-4 text-primary bg-light-grey border-light-grey rounded-sm focus:ring-primary">
                            <label for="family-{{i}}" class="ms-2 text-sm font-medium">
                                @switch (family) {
                                @case ('One shot purchase') {
                                {{
                                "pages.marketplace-page.filters.oneShotPurchaseLabel"
                                | transloco
                                }}
                                }
                                @case ('Subscription') {
                                {{
                                "pages.marketplace-page.filters.subscriptionLabel" | transloco
                                }}
                                }
                                }</label>
                        </div>
                    </div>

                    <hr class="my-5 border-light-grey" />

                    <div class="flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-4">
                            <label class="font-semibold text-base">Durata (se abbonamento)</label>
                            <button type="button" class="text-base text-danger font-light" (click)="resetSubscriptionRecurringPeriod()">Ripristina
                            </button>
                        </div>
                        <div class="flex items-center mb-4" *ngFor="let period of availableFilters.subscriptionRecurringPeriod; let i = index">
                            <input [formControl]="searchProductFilterForm.controls.subscriptionRecurringPeriod.controls[i]" id="period-{{i}}" type="checkbox" class="w-4 h-4 text-primary bg-light-grey border-light-grey rounded-sm focus:ring-primary">
                            <label for="period-{{i}}" class="ms-2 text-sm font-medium">
                                {{
                                "pages.marketplace-page.filters." + period + "Label" | transloco
                                }}
                            </label>
                        </div>
                    </div>

                    <hr class="my-5 border-light-grey" />

                    @if (availableFilters.goals.length > 0) {
                    <div class="flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-4">
                            <label class="font-semibold text-base">Obiettivo</label>
                            <button type="button" class="text-base text-danger font-light" (click)="resetGoals()">
                                Ripristina
                            </button>
                        </div>
                        <div class="flex items-start justify-start flex-wrap">
                            <label *ngFor="let goal of availableFilters.goals; let i = index" class="cursor-pointer px-4 py-2 rounded-xl border mr-2 mb-4 inline-block text-sm border-primary transition-color duration-75 capitalize" [class.bg-primary]="searchProductFilterForm.controls.goals.controls[i].value" [class.text-white]="searchProductFilterForm.controls.goals.controls[i].value" [class.bg-white]="!searchProductFilterForm.controls.goals.controls[i].value" [class.text-primary]="!searchProductFilterForm.controls.goals.controls[i].value">
                                <input type="checkbox" class="hidden" [formControl]="searchProductFilterForm.controls.goals.controls[i]" />
                                {{ goal }}
                            </label>

                        </div>
                    </div>

                    <hr class="my-5 border-light-grey" />}

                    <div class="flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-4">
                            <label class="font-semibold text-base">Range prezzo</label>
                            <button type="button" class="text-base text-danger font-light" (click)="resetMaxPrice()">Ripristina
                            </button>
                        </div>

                        <ngx-slider [options]="priceRangeOptions" [formControl]="searchProductFilterForm.controls.maxPrice"></ngx-slider>
                    </div>

                    <hr class="my-5 border-light-grey" />

                    <div class="flex flex-row justify-between items-center mb-4">
                        <button type="button" class="text-base text-danger font-light" (click)="resetForm()">
                            Ripristina tutto
                        </button>
                        <button type="submit" class="cursor-pointer bg-primary text-white px-4 py-2 rounded-xl mr-2 inline-block text-sm hover:bg-primary-dark">
                            Applica
                        </button>
                    </div>
                </div>
            </form>
        </div>
        }
    </div>
</div>
